import React from 'react';
import { LOADING_SCREEN } from '../../utils/constants';
import { getText } from '../../utils/functions';
import Spinner from '../basicComponents/Spinner';
import mainLogo from '../../../assets/img/logo_animation.svg';
import downLogo from '../../../assets/img/councilpoweredby2.png';

function LoadingPage({
	translate,
	colors,

	/* OPTIONAL PROPS */
	classNameDIV = 'relative w-full px-8 md:px-30 lg:px-52 py-4 h-screen flex flex-col items-center content-center justify-center',
	styleDIV,
	classNameSPINNER = 'h-20 md:h-40 mb-8',
	classNameIMG = 'absolute bottom-0 h-16 md:h-24 mb-8',
	styleIMG,
	classNameTEXT = 'text-cbx-greyblue md:text-xl',
	styleTEXT,
}) {
	/* Default values for the styles */
	const defaultStyleDIV = {
		backgroundColor: colors?.background,
		transition: 'all 100ms ease-in',
	};
	const defaultStyleIMG = {
	};
	const defaultStyleTEXT = {
	};

	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideStyleDIV = { ...defaultStyleDIV, ...styleDIV };
	const overrideStyleIMG = { ...defaultStyleIMG, ...styleIMG };
	const overrideStyleTEXT = { ...defaultStyleTEXT, ...styleTEXT };

	return <div
		id='LOADING'
		className={classNameDIV}
		style = {overrideStyleDIV}
	>
		<Spinner
			src={mainLogo}
			className={classNameSPINNER}
		/>
		<div
			className={classNameTEXT}
			style= {overrideStyleTEXT}
			dangerouslySetInnerHTML={{ __html: getText(LOADING_SCREEN.information, translate) }}
		/>
		<img
			src={downLogo}
			className={classNameIMG}
			style={overrideStyleIMG}
		/>
	</div>;
}

export default LoadingPage;
